/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomVersionSubmittedByQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AppSecopsSbomVersionSubmittedByQueryOperator");
    }

    getFixupPrototypeFunction() { return AppSecopsSbomVersionSubmittedByQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomVersionSubmittedByQueryOperator>): AppSecopsSbomVersionSubmittedByQueryOperator {
        let obj = Object.assign(new AppSecopsSbomVersionSubmittedByQueryOperator(), model);
        AppSecopsSbomVersionSubmittedByQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomVersionSubmittedByQueryOperator>): AppSecopsSbomVersionSubmittedByQueryOperator {
        if (!model) return null;
        return AppSecopsSbomVersionSubmittedByQueryOperator.newInstance(<AppSecopsSbomVersionSubmittedByQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomVersionSubmittedByQueryOperator) {
        if (!obj) return;

        models.AppSecopsSbomVersionSubmittedByQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomVersionSubmittedByQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsSbomVersionSubmittedByQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * User who submitted SBOM version to include
     */
    sbom_submitted_by: Array<string>;

}
